import "./breathe.css";

/**
 * FD-CAN-39 — the breath (see breathe.css for the stepped, stillable law).
 * The class a wearer mounts on its glyph ONLY while the thing the glyph names
 * is alive — motion is information, never decoration — and removes the moment
 * it settles. The glyph keeps its own color: the bloom is currentColor.
 */
export const BREATHE_CLASS = "ncl-breathe";
